export default __webpack_public_path__ + "static/media/Odyssey.06e2a0ff.svg";